
import skills from './skills';

export default {
  skills,
};
